import axios from 'axios'
import store from '../store'
import alert from './alert'
import { KEYS, getItem } from '@/store/localStorage'
import messages from '@/constants/messages'
import FileSaver from 'file-saver'
import { getHorario } from '../services/api/api'

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSBLE_ENTITY: 422
}

let loaderCount = 0

const setLoader = (loader, loaderText) => {
  if (loader) {
    loaderCount++

    if (loaderCount === 1) {
      if (loaderText) {
        store.commit('loader/SET_LOADER_WITH_TEXT', { status: loader, text: loaderText })
      } else {
        store.commit('loader/SET_LOADER')
      }
    }
  }
}

const disableLoader = loader => {
  if (loader) {
    loaderCount--

    if (loaderCount === 0) {
      store.commit('loader/RESET_LOADER')
    }
  }
}

const setDefaultOptions = options => {
  const token = getItem(KEYS.LOGIN.jwt)

  options.headers = {
    Authorization: token,
    ...options.headers
  }

  options.loader = options.loader !== false

  return options
}

const verifyDownloadOnPost = (config, response) => {
  if (config.method && config.method.toUpperCase() === 'POST' && response.data.type === 'application/octet-stream') {
    if (response.headers['content-disposition']) {
      var fileName = response.headers['content-disposition'].split('filename=')[1]
      FileSaver.saveAs(response.data, fileName)
    }
  }
}

const handleRequestPromisse = config => {
  config = setDefaultOptions(config)

  if (config.responseType === 'blob' && (config.method === 'GET' || config.method === 'get')) {
    window.open(config.url)
    return
  }

  setLoader(config.loader, config.loaderText)

  return new Promise((resolve, reject) => {
    axios(config).then(response => {
      verifyDownloadOnPost(config, response)

      disableLoader(config.loader)

      return resolve(response.data)
    }).catch(async error => {
      disableLoader(config.loader)

      let { status, message, messageTitle, erros } = config.responseType !== 'arraybuffer' ? error.response.data : JSON.parse(new TextDecoder('utf-8').decode(error.response.data))

      if (config.notMessage) {
        return
      }

      if (status === HTTP_STATUS.UNAUTHORIZED) {
        alert.warning({
          title: 'Sua sessão expirou!',
          msg: `Faça o login novamente.' ${getHorario()}`
        })
        return
      }

      if (!message && (!erros || erros.length === 0)) {
        message = messages.ERROR_MESSAGE
        messageTitle = 'Erro!'
        alert.error({
          title: messageTitle,
          msg: `${message} ${getHorario()}`
        })
        return
      }

      if (message && (!erros || erros.length === 0) && messageTitle) {
        if (status >= 500) {
          alert.error({
            title: messageTitle,
            msg: `${message} ${getHorario()}`
          })
        } else {
          alert.warning({
            title: messageTitle,
            msg: `${message} ${getHorario()}`
          })
        }
      } else if (erros && erros.length) {
        let mensagemErro = ''
        erros.map(erro => { mensagemErro += erro + '<br/>' })
        if (status >= 500) {
          alert.error({
            title: messageTitle,
            msg: `${mensagemErro} ${getHorario()}`
          })
        } else {
          alert.warning({
            title: messageTitle,
            msg: `${mensagemErro} ${getHorario()}`
          })
        }
      } else if (message && !messageTitle) {
        if (status >= 500) {
          alert.error({
            title: 'Erro!',
            msg: `${message} ${getHorario()}`
          })
        } else {
          alert.warning({
            title: 'Atenção!',
            msg: `${message} ${getHorario()}`
          })
        }
      } else if (message && messageTitle) {
        if (status >= 500) {
          alert.error({
            title: messageTitle,
            msg: `${message} ${getHorario()}`
          })
        } else {
          alert.warning({
            title: messageTitle,
            msg: `${message} ${getHorario()}`
          })
        }
      }

      if (config.error || status === HTTP_STATUS.UNPROCESSBLE_ENTITY) {
        return reject(error.response.data)
      }
    })
  })
}

export default handleRequestPromisse
